module.exports = __webpack_public_path__ + "img/completed.6da43050.png";